import { ApplicationView } from "@mixitone/mvc";
import { RouteLoadNotFoundProvider, Routes } from "@mixitone/router";
import RouteController from "controllers/RouteController";
import SessionController from "controllers/SessionController";
import NotFound from "pages/not_found";

const Session = () => {
  return (
    <RouteLoadNotFoundProvider render={() => <NotFound />}>
      <Routes includeModals={false} />
    </RouteLoadNotFoundProvider>
  );
};

export default RouteController.scope(SessionController.scope(ApplicationView(Session)));
